// OAuth2 Authentication Module

import api from './api.js';

class AuthManager {
  constructor() {
    this.user = null;
    this.checkAuthOnLoad();
  }

  async checkAuthOnLoad() {
    // Check if we have tokens in localStorage
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      try {
        this.user = await api.getCurrentUser();
        this.onAuthStateChanged();
      } catch (error) {
        console.error('Failed to get current user:', error);
        this.clearAuth();
      }
    }

    // Handle OAuth callback
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('access_token')) {
      this.handleOAuthCallback(urlParams);
    }
  }

  handleOAuthCallback(urlParams) {
    const accessToken = urlParams.get('access_token');
    const refreshToken = urlParams.get('refresh_token');

    if (accessToken) {
      localStorage.setItem('access_token', accessToken);
      if (refreshToken) {
        localStorage.setItem('refresh_token', refreshToken);
      }

      // Remove tokens from URL
      window.history.replaceState({}, document.title, window.location.pathname);

      // Fetch user data
      api.getCurrentUser()
        .then((user) => {
          this.user = user;
          this.onAuthStateChanged();
        })
        .catch((error) => {
          console.error('Failed to get user after OAuth:', error);
          this.clearAuth();
        });
    }
  }

  loginWithGoogle() {
    // Use absolute URL to bypass Vite's SPA routing
    window.location.href = `${window.location.origin}/api/v1/auth/google`;
  }

  loginWithMicrosoft() {
    // Use absolute URL to bypass Vite's SPA routing
    window.location.href = `${window.location.origin}/api/v1/auth/microsoft`;
  }

  async logout() {
    try {
      await api.logout();
    } catch (error) {
      console.error('Logout request failed:', error);
    }
    this.clearAuth();
  }

  clearAuth() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    this.user = null;
    this.onAuthStateChanged();
  }

  isAuthenticated() {
    return !!this.user;
  }

  getUser() {
    return this.user;
  }

  // Override this method to handle auth state changes
  onAuthStateChanged() {
    // This will be overridden by the app
    console.log('Auth state changed:', this.isAuthenticated());
  }
}

export default new AuthManager();
